module.exports = __webpack_public_path__ + "static/media/promo_natural_stone_catalog_v2.3c18fe05.png";